export default __webpack_public_path__ + "static/ico-mvv-79fc32f1e1cd5fdb2f105db2c62bf853.svg";